module.exports = "/dist/assets/images/arrow-white.svg";